export default "__VITE_ASSET__GOhcC7LA__"